<template>
	<div>
		<canvas
		v-on:mousedown="handleMouseDown"
		v-on:mouseup="handleMouseUp"
		id="canvas"
		:style="`visibility: ${readOnly ? 'hidden' : ''};`"></canvas>
		<div v-if="readOnly" v-show="false" ref="imageViewer" class="images" v-viewer="{navbar: false,toolbar: false,inline: true, title: false}">
      		<img :src="downloadImageHref">
    	</div>
		<base-button
			v-if="!readOnly"
			:title="$t('app.locations.delete_point')"
			:classNames="`btn btn-default btn-outline rounded`"
			@clicked="clearDots"
		/>
	</div>
</template>

<script>
import BaseButton from '@/components/shared/buttons/BaseButton';

export default {
  name: 'Canvas',
  components: {
    'base-button': BaseButton,
  },
  props: {
    imageUrl: {
      type: String,
      required: false,
    },
    area: {
      type: Array,
      required: false,
    },
    selectedColor: {
      type: String,
      required: false,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      downloadImageHref: undefined,
      canvas: undefined,
      ctx: undefined,
      mousedown: false,
      last_mousex: 0,
      last_mousey: 0,
      coordinates: [],
      percentCoordinates: [],
      dotCount: 0,
      opacity: 50,
    };
  },
  created() {
  },
  mounted() {
    if (this.imageUrl && this.area) {
      this.drawBacgkroundImage(this.imageUrl, this.area, this);
    } else {
      this.drawBacgkroundImage(this.imageUrl);
    }
  },
  methods: {
    clearDots() {
      this.coordinates = [];
      this.percentCoordinates = [];
      this.drawBacgkroundImage(this.imageUrl);
    },
    handleMouseDown(e) {
      if (!this.readOnly) {
        const rect = this.canvas.getBoundingClientRect();
        this.last_mousex = parseInt(e.clientX - rect.left);
        this.last_mousey = parseInt(e.clientY - rect.top);

        this.coordinates.push({ x: this.last_mousex, y: this.last_mousey }); // store coordinates
        this.percentCoordinates.push([this.last_mousex / this.canvas.width * 100, this.last_mousey / this.canvas.height * 100]); // store coordinates in percent
        this.dotCount = this.coordinates.length; // get the number of dots
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
        this.drawBacgkroundImageOnly(this.imageUrl);
        this.drawPolygon(this.coordinates);
        this.mousedown = true;
      }
    },
    drawPolygon(coordinates) {
      const rect = this.canvas.getBoundingClientRect();
      const color = this.convertHex(this.selectedColor);
      const ctx = this.ctx;
      this.ctx.strokeStyle = color; // set style for line
      this.ctx.fillStyle = color; // set style for circle
      this.ctx.beginPath(); // start drawing circle
      this.ctx.arc(this.last_mousex, this.last_mousey, 2, 0, 2 * Math.PI); // set circle's position
      this.ctx.fill(); // create circle
      ctx.globalCompositeOperation = 'destination-over';
      ctx.beginPath();
      coordinates.forEach((coordinate, index) => {
        if (index === 0 && coordinates[index + 1] !== undefined) {
          ctx.moveTo(coordinates[index].x, coordinates[index].y); // set start point for line
          ctx.stroke();
        } else if (coordinates[index + 1] !== undefined) {
          ctx.lineTo(coordinates[index].x, coordinates[index].y); // set end point for line
        } else if (coordinates.length > 1 && coordinates[index + 1] === undefined) {
          ctx.lineTo(coordinates[index].x, coordinates[index].y); // set end point for line
          ctx.lineTo(coordinates[0].x, coordinates[0].y); // set start point for line
          ctx.stroke();
        }
      });
      ctx.closePath();
      ctx.fill();
    },
    handleMouseUp() {
      this.$emit('addCoordinate', this.percentCoordinates);
      this.mousedown = false;
    },
    drawBacgkroundImage(url, area, main) {
      this.coordinates = [];
      const canvas = document.getElementById('canvas');
      this.canvas = canvas;
      const canvasx = canvas.offsetWidth;
      const canvasy = canvas.offsetHeight;

      this.canvas.width = canvasx;
      this.canvas.height = canvasy;
      canvas.width = canvasx;
      canvas.height = canvasy;

      const color = this.convertHex(this.selectedColor);
      const image = new Image();
      image.crossOrigin = 'Anonymous';
      image.src = url;
      const ctx = this.canvas.getContext('2d');
      this.ctx = ctx;
      image.onload = function () {
        const ratio = canvas.width / image.width;
        canvas.height = image.height * ratio;
        ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
        ctx.strokeStyle = color; // set style for line
        ctx.fillStyle = color; // set style for circle

        if (area && area !== null && area !== undefined) {
          ctx.beginPath();
          area.forEach((coordinate, index) => {
            if (index === 0 && area[index + 1] !== undefined) {
              ctx.moveTo(area[index][0] / 100 * canvasx, area[index][1] / 100 * canvas.height); // set start point for line
            } else if (area[index + 1] !== undefined) {
              ctx.lineTo(area[index][0] / 100 * canvasx, area[index][1] / 100 * canvas.height); // set end point for line
              ctx.stroke();
            } else if (area.length > 1 && area[index + 1] === undefined) {
              ctx.lineTo(area[index][0] / 100 * canvasx, area[index][1] / 100 * canvas.height); // set end point for line
              ctx.lineTo(area[0][0] / 100 * canvasx, area[0][1] / 100 * canvas.height); // set start point for line
              ctx.stroke();
            }
          });
          ctx.closePath();
          ctx.fill();
        }
        main.downloadImageHref = canvas.toDataURL('image/png');
      };
    },
    drawBacgkroundImageOnly(url) {
      const canvas = document.getElementById('canvas');
      this.canvas = canvas;
      const canvasx = canvas.offsetWidth;
      const canvasy = canvas.offsetHeight;

      this.canvas.width = canvasx;
      this.canvas.height = canvasy;
      canvas.width = canvasx;
      canvas.height = canvasy;
      const image = new Image();
      image.src = url;
      const ctx = this.canvas.getContext('2d');
      this.ctx = ctx;

      image.onload = function () {
        ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0,
          canvas.width, canvas.height);
      };
    },
    compare(a, b) {
      const distanceA = a.distance;
      const distanceB = b.distance;

      let comparison = 0;

      if (distanceA > distanceB) {
        comparison = 1;
      } else if (distanceA < distanceB) {
        comparison = -1;
      }
      return comparison;
    },
    convertHex(color) {
      color = color.replace('#', '');
      const r = parseInt(color.substring(0, 2), 16);
      const g = parseInt(color.substring(2, 4), 16);
      const b = parseInt(color.substring(4, 6), 16);
      const result = `rgba(${r},${g},${b},${this.opacity / 100})`;
      return result;
    },
  },
  watch: {
    imageUrl(newValue, oldvalue) {
      this.coordinates = [];
      this.percentCoordinates = [];
      this.drawBacgkroundImage(newValue);
    },
    selectedColor(newValue, oldvalue) {
      this.coordinates = [];
      this.percentCoordinates = [];
      this.drawBacgkroundImage(this.imageUrl);
    },
  },
};
</script>

<style lang="scss">

#canvas {
	width: 100%;
	// background-size: cover !important;
	// background-repeat: no-repeat !important;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/inputs/Canvas.vue